var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPublications = function SvgPublications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "publications_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 15h6.666v-1.667H6.667V15Zm0-3.333h6.666V10H6.667v1.667ZM5 18.333c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176V3.333c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49h6.667l5 5v10c0 .459-.164.851-.49 1.178-.326.326-.719.49-1.177.49H5ZM10.833 7.5H15l-4.167-4.167V7.5Z",
    fill: "currentColor"
  })));
};
export { SvgPublications as ReactComponent };